import { Component, OnInit } from '@angular/core';
import { Filterable } from '@common/utilities/Filterable';
import { ServiceRecord, ServiceGroupRecord, DataService } from '@core/services/data.service';
import { Lookup } from '@common/utilities/Lookup';
import { ModalService } from '@common/services/modal.service';
import { GroupEditorComponent } from '@routes/editors/group-editor/group-editor.component';
import { ServiceEditorComponent } from '@routes/editors/service-editor/service-editor.component';
import { SynchronizationService } from '@core/services/synchronization.service';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

  constructor(private ds: DataService, private modal: ModalService, private sync: SynchronizationService) { }

  public services = new Filterable<ServiceRecord>({
    extractor: i => [i.Name, i.Address],
    grouper: i => [{ name: 'Nhóm', option: this.group(i) }]
  });

  public groups = new Filterable<ServiceGroupRecord>({
    extractor: i => [i.Name]
  });

  public mode: 'groups' | 'services' = 'services';

  public get loading(): boolean {
    return !this.sync.ready(ServicesComponent);
  }

  private groupLU = new Lookup<ServiceGroupRecord>(i => i.ID);

  public group(service: ServiceRecord): string {
    return this.groupLU.get(service.GroupID, { ID: service.GroupID, Name: '#' + service.GroupID, Description: '' }).Name;
  }

  ngOnInit(): void {

    this.sync.with(ServicesComponent).repeat(

      () => this.ds.groups('list').pipe(map(groups => {

        if (groups) {
          this.groupLU.source = groups;
          this.groups.source = groups;

          return true;
        }
        return false;
      })),

      () => this.ds.services('list').pipe(map(services => {

        if (services) {
          this.services.source = services;
          if (services.length < 1) this.mode = 'groups';

          return true;
        }

        return false;
      }))
    );    
  }

  public editService(service: ServiceRecord) {
    this.modal.show(ServiceEditorComponent, { state: { service: service } }).content.change.subscribe(updated => {
      this.services.source = this.services.source.filter(i => i != service).union([updated]);
    });
  }

  public editGroup(group: ServiceGroupRecord) {
    this.modal.show(GroupEditorComponent, { state: { group: group } }).content.change.subscribe(updated => {

      this.groupLU.remove(group);
      this.groupLU.add(updated);

      this.groups.source = this.groups.source.filter(i => i != group).union([updated]);      
    });
  }
}
